<template>
		<div id="message-container" style="overflow: auto;">
				<md-card style="height: 100%;width: 100%;">
						<md-card-header>
								<h3>Редактирование сообщения</h3>
						</md-card-header>

						<md-card-content style="height: 85%">
								<md-field style="height: 97%">
										<md-textarea
														style="resize:none;height: 100%;font-size: 0.8rem;padding-bottom: 10px;"
														:placeholder="message"
														v-model.lazy.trim="message"
														ref="focusItem"
										></md-textarea>
								</md-field>
						</md-card-content>

						<md-card-actions>
								<md-button class="md-dense md-primary"
								           @click="save(message, dataObj.editableMessage.messageNpp, dataObj.userId)"
								           :disabled="message === initialMessage"
								>
										Сохранить
								</md-button>
								<md-button class="md-dense md-accent" @click="cancel">Отмена</md-button>
						</md-card-actions>
				</md-card>
		</div>
</template>

<script>
	export default {
		name: "editMessageWindow",
		data: () => ({
			message: '',
			initialMessage: ''
		}),
		props: ['dataObj'],
		methods: {
			async save(message, messageNpp, userId) {
				if (!messageNpp) return this.$store.dispatch("showSnackBar", {snackText: "Ошибка! Не определен messageNpp"});
				try {
					const response = await this.$http.put("data/UpdateMessageText", {message, messageNpp, userId}, {emulateJSON: true});
					if (response.body.statusCode > 200) {
						const errorMessage = response.body.reasonPhrase;
						console.error(errorMessage);
						return this.$store.dispatch("showSnackBar", {snackText: `Ошибка! ${errorMessage}`});
					}
				} catch (error) {
					console.error(error);
					return this.$store.dispatch("showSnackBar", {snackText: `Ошибка! ${error.message}`});
				}
				this.$store.dispatch("showSnackBar", {snackText: 'Текст сообщения успешно изменен'});
				this.$emit("updateMessages");
				this.$emit("closeEditMessageWindow");
			},
			cancel() {
				this.$emit("closeEditMessageWindow");
			}
		},
		mounted() {
			this.message = this.dataObj.editableMessage.text.trim();
			this.initialMessage = this.message;
			setTimeout(() => {
				this.$refs.focusItem.$el.focus();
			}, 200);
		}
	}
</script>

<style scoped>
		p {
				margin-top: 5px;
				margin-bottom: 5px;
		}

		h3 {
				margin-bottom: 0;
				margin-top: 0;
		}

		.md-field {
				margin-bottom: 0;
		}

		.md-button {
				font-size: 12px;
		}

		.md-field .md-textarea {
				max-height: 100%;
		}

		#message-container {
				height: 100%;
		}
</style>


// WEBPACK FOOTER //
// Components/supportNew/editMessageWindow.vue